module.exports = __webpack_public_path__ + "img/chain.dc6e0c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blockChain/chain.png
// module id = 1byd
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37